<template>
  <div class="wrapper" style="overflow: hidden">
    <!-- <el-carousel trigger="click" :interval="5000" style="height: 100vh">
      <el-carousel-item
        v-for="item in carousel"
        :key="item.image"
        style="height: 100vh"
      >
        <div class="carousel-center">
          <h2>{{ item.caption }}</h2>
          <h1 style="font-size: 72px; font-weight: bold">{{ item.title }}</h1>
          <md-button
            href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
            class="md-primary md-sm"
            target="_blank"
          >
            <i class="fas fa-play" /> Watch video
          </md-button>
        </div>

        <div class="full-carousel-image darkened">
          <img :src="item.image" :alt="image.title" />
        </div>
      </el-carousel-item>
    </el-carousel> -->

    <img :src="header"/>
    <div class="main">
      <!-- Description start -->
      <div class="md-layout section">
        <div class="md-layout-item md-size-100 mx-auto text-center">
          <h2 class="title section-heading" v-html="description.title"></h2>
          <h4
            style="margin: 0 18%"
            v-html="description.description"
            class=""
          ></h4>
        </div>
      </div>
      <!-- Description end -->

      <!-- Services start -->

      <div class="section section-dark text-white text-center">
            <h1>Services</h1>


      <div
        class="md-layout md-alignment-center text-center"
        style="flex-wrap: wrap"
      >
        <div v-for="(service, index) in services" :key="index" class="md-layout-item md-size-33 md-small-size-100">
          <h2 v-html="service.title" />
          <!-- <md-icon style="margin: 2%" class="text-white md-size-2x">{{
            service.icon
          }}</md-icon> -->
           <img style="margin: 2%" :src="service.image" :alt="service.title" />
          <p v-html="service.description" />
        </div>
      </div>
      </div>

      <!-- Services end -->

      <!-- What we offer start -->

      <div class>
        <div class="md-layout" style="margin-left: 0; margin-right: 0">
          <div
            class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
          >
            <h2 class="title">What we offer</h2>
          </div>
        </div>

        <!-- Layout begins -->
        <div
          class="md-layout"
          style="margin-left: 0; margin-right: 0; background-color: whitesmoke"
        >
          <!-- Left slide -->
          <div
            class="md-layout-item md-size-32 md-small-size-100"
            style="height: 80vh; padding: 0"
          >
            <div class="md-layout" style="margin-left: 0; margin-right: 0">
              <!-- Left top -->
              <div
                class="md-layout-item md-size-100 md-small-size-100 subtle-shadow"
                style="height: 40vh; padding: 0"
              >
                <img
                  :src="whatWeOffer.left.image"
                  style="height: 40vh; width: 100%"
                />
              </div>
              <!-- Left bottom -->
              <div
                class="md-layout-item md-size-100 md-small-size-100"
                style="height: 40vh"
              >
                <div class="text-center whatSetsUsApart-container">
                  <h3 class="whatSetsUsApart-content">
                    {{ whatWeOffer.left.title }}
                  </h3>
                  <p class="whatSetsUsApart-content">
                    {{ whatWeOffer.left.info }}
                  </p>
                </div>
                <md-divider
                  style="
                    background-color: midnightblue;
                    height: 1px;
                    margin-left: 40%;
                    margin-right: 40%;
                    width: auto;
                  "
                ></md-divider>
              </div>
            </div>
          </div>

          <!-- Middle slide -->
          <div
            class="md-layout-item md-size-32 md-small-size-100"
            style="background-color: whitesmoke; height: 80vh; padding: 0"
          >
            <div class="md-layout" style="margin-left: 0; margin-right: 0">
              <!-- Middle top -->
              <div
                class="md-layout-item md-size-100 md-small-size-100"
                style="height: 40vh"
              >
                <div class="text-center whatSetsUsApart-container">
                  <h3 class="whatSetsUsApart-content">
                    {{ whatWeOffer.middle.title }}
                  </h3>
                  <p class="whatSetsUsApart-content">
                    {{ whatWeOffer.middle.info }}
                  </p>
                </div>
                <md-divider
                  style="
                    background-color: midnightblue;
                    height: 1px;
                    margin-left: 40%;
                    margin-right: 40%;
                    width: auto;
                  "
                ></md-divider>
              </div>
              <!-- Middle bottom -->
              <div
                class="md-layout-item md-size-100 md-small-size-100 subtle-shadow"
                style="height: 40vh; padding: 0"
              >
                <img
                  :src="whatWeOffer.middle.image"
                  style="height: 40vh; width: 100%"
                />
              </div>
            </div>
          </div>

          <!-- Right slide -->
          <div
            class="md-layout-item md-size-32 md-small-size-100"
            style="height: 80vh; padding: 0"
          >
            <div class="md-layout" style="margin-left: 0; margin-right: 0">
              <!-- Right top -->
              <div
                class="md-layout-item md-size-100 md-small-size-100 subtle-shadow"
                style="height: 40vh; padding: 0"
              >
                <img
                  :src="whatWeOffer.right.image"
                  style="height: 40vh; width: 100%"
                />
              </div>
              <!-- Right bottom -->
              <div
                class="md-layout-item md-size-100 md-small-size-100"
                style="height: 40vh"
              >
                <div class="text-center whatSetsUsApart-container">
                  <h3 class="whatSetsUsApart-content">
                    {{ whatWeOffer.right.title }}
                  </h3>
                  <p class="whatSetsUsApart-content">
                    {{ whatWeOffer.right.info }}
                  </p>
                </div>
                <md-divider
                  style="
                    background-color: midnightblue;
                    height: 1px;
                    margin-left: 40%;
                    margin-right: 40%;
                    width: auto;
                  "
                ></md-divider>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- What we offer end -->

      <!-- Portfolio tabs start -->
      <!-- <div class="md-layout section">
        <div
          class="md-layout-item md-size-100 md-small-size-100"
          style="padding-right: 0; padding-left: 0"
        >
          <tabs
            :tab-active="1"
            :tab-name="projectList"
            :tab-icon="['dashboard', 'schedule', 'list']"
            plain
            nav-pills
            color-button="primary"
            pillsAlign="center"
          > -->
            <!-- here you can add your content for tab-content -->

            <!-- Slot 1 starts -->
            <!-- <div slot="tab-pane-1">
              <masonry :cols="{ default: 3, 700: 2, 400: 1 }" :gutter="5">
                <div v-for="(item, index) in portfolio.wallart" :key="index">
                  <div class="portfolio-container" style="margin-bottom: 5px">
                    <img :src="item.image" :alt="item.title" />
                    <div class="portfolio-overlay">
                      <md-divider class="portfolio-divider"></md-divider>
                      <h3 class="portfolio-title">{{ item.title }}</h3>
                      <h5 class="portfolio-caption">{{ item.text }}</h5>
                    </div>
                  </div>
                </div>
              </masonry>
            </div> -->
            <!-- Slot 1 ends -->
          <!-- </tabs>
        </div>
      </div> -->
      <!-- Portfolio end -->

      <div class="text-center section">
        <h2 class="title">
        Our Process
        </h2>
        <img :src="process.image"/>
      </div>

      <!-- Testimonials Begin -->

      <!-- https://element.eleme.io/?ref=madewithvuejs.com#/en-US/component/carousel -->

      <!-- <div class="section section-testimonials-2 section-dark">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <el-carousel
                indicator-position="outside"
                arrow="never"
                trigger="click"
                :interval="5000"
              >
                <el-carousel-item>
                  <testimonial-card card-plain>
                    <div slot="cardAvatarTop" class="md-card-avatar mt-0">
                      <a href="javascript:void(0)">
                        <img class="img" :src="cardProfile3.cardProfile1" />
                      </a>
                    </div>
                    <template slot="cardContent">
                      <h5 class="card-description">
                        "I speak yell scream directly at the old guard on behalf
                        of the future. I gotta say at that time I’d like to meet
                        Kanye I speak yell scream directly at the old guard on
                        behalf of the future. My brother Chance!!!
                        <br />Thank you for letting me work on this masterpiece.
                        One of my favorite people."
                      </h5>
                      <h4 class="card-title">Kendall Thompson</h4>
                      <h6 class="card-category text-muted">
                        CEO @ Marketing Digital Ltd.
                      </h6>
                    </template>
                  </testimonial-card>
                </el-carousel-item>
                <el-carousel-item>
                  <testimonial-card card-plain>
                    <div slot="cardAvatarTop" class="md-card-avatar mt-0">
                      <a href="javascript:void(0)">
                        <img class="img" :src="cardProfile3.cardProfile2" />
                      </a>
                    </div>
                    <template slot="cardContent">
                      <h5 class="card-description">
                        "Thank you Anna for the invite thank you to the whole
                        Vogue team Called I Miss the Old Kanye At the God's last
                        game Chop up the soul Kanye. I promise I will never let
                        the people down. I want a better life for all!!! Pablo
                        Pablo Pablo Pablo! Thank you Anna for the invite thank
                        you to the whole Vogue team."
                      </h5>
                      <h4 class="card-title">Christian Louboutin</h4>
                      <h6 class="card-category text-muted">
                        Designer @ Louboutin &amp; Co.
                      </h6>
                    </template>
                  </testimonial-card>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div> -->
      <!--Testimonials End -->

      <!-- Clients start -->

      <div>
        <h2 class="title text-center">Our clients</h2>
        <!-- <agile :options="clients.options" style="style=transform: translate(0px); max-height: 20vh;"> -->

        <div
          class="md-layout md-alignment-center-center"
          style="max-height: 30vh"
        >
          <div
            v-for="logo in clients.logos"
            :key="logo"
            class="md-layout-item md-size-15 md-small-size-50"
            style="height: 30vh"
          >
            <img
              style="height: 20vh; width: auto; object-fit: contain"
              :src="require('@/assets/img/logos/' + logo)"
            />
          </div>
        </div>
        <!-- </agile> -->
      </div>

      <!-- Love to hear more start -->
      <div
        class="section section-dark md-layout md-alignment-center text-white text-center"
      >
        <div class="md-layout-item md-size-30">
          <h3>We would love to hear about your project</h3>
        </div>
        <div class="md-layout-item md-size-20">
          <md-button class="md-primary">Get in touch</md-button>
        </div>
      </div>
    <!-- Love to hear more end -->

    <!-- Blog cards start -->
    <!-- <div
      class="section"
    >
      <h2 class="title text-center">Latest Blogs</h2>
      <div class="md-layout md-alignment-top-center md-gutter" style="">
        <md-card
          class="md-layout-item md-size-20 md-medium-size-40 md-small-size-75"
          style="
            overflow: hidden;
            padding: 0;
            margin-left: 0.5%;
            margin-right: 0.5%;
            height: 50vh;
          "
          v-for="blog in blogs"
          :key="blog.id"
        >
          <div
            class="md-layout md-align-around-center"
            v-on:click="openBlog(blog.id, blog.title)"
            style="height: 100%; overflow: hidden; flex: 1 0 auto"
          >
            <div class="md-layout-item md-size-100" style="padding: 0">
              <img
                :src="blog.cover"
                style="object-fit: cover; height: 32.5vh"
              />
            </div>
            <div class="md-layout-item md-size-100" style="">
              <h4 class="title text-rose" style="color: black !important">
                {{ blog.title }}
              </h4>
              <div class="caption">{{ blog.author }}</div>
              <p class="description text-rose">
                {{ blog.created.d }}-{{ blog.created.m }}-{{ blog.created.y }}
              </p>
            </div>
          </div>
        </md-card>
      </div>
    </div> -->
    <!-- Blog cards end -->


            <!-- FAQ Start -->
        <div class="section">
          <h2 class="title text-center">Frequently Asked Questions</h2>
          <div class="md-layout md-alignment-center">
            <div class="md-layout-item md-size-66 md-small-size-100">
              <collapse
                :active-tab="0"
                :collapse="faqs.map(faq => faq.ques)"
                icon="keyboard_arrow_down"
                color-collapse="rose"
              >
                <template v-for="(faq, index) in faqs" :slot="'md-collapse-pane-' + (index+1)">
                  <div :key="index">
                  <p>
                  {{faq.ans}}
                  </p>
                  </div>
                </template>
              </collapse>
            </div>
          </div>
        </div>
        <!-- FAQ end -->


        </div>

  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import { Tabs, Collapse, TestimonialCard } from "@/components";
import firebase from "firebase";


export default {
  components: {
    Tabs,
    Collapse,
    TestimonialCard,
  },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",
  data() {
    return {
      header: require("@/assets/img/wall-art/header.png"),
      blogs: [],
      image: require("@/assets/img/landing-illustration.jpg"),
      services: [
        {
          title: "​Interior Wall Designs​",
          icon: "3d_rotation",
          image: require("@/assets/img/wall-art/interior_designs.png"),
          description: `An array of customized Wall Art to meet every unique need.`,
        },
        {
          title: "​Wall Installations",
          icon: "3d_rotation",
          image: require("@/assets/img/wall-art/wall_installations.png"),
          description: `Wallpapers, 3-D and wooden installations, thread-woven designs, direct-painting artwork, and more.`,
        },
        {
          title: "​Exterior Wall Designs​",
          icon: "3d_rotation",
          image: require("@/assets/img/wall-art/exterior_designs.png"),
          description: `Adaptable to changing climates, altered as per your wall’s surface material.`,
        }
      ],
      description: {
        title: `Why choose wall art`,
        description: `By capturing your visitors' attention, Wall Art peaks your interior design by
providing a unique color palette, and forms a focal point in the room. Brands
could use Wall Art as a way to advertise their mission and vision, gaining
maximum traffic. Let your Wall Art speak for you and boost your ambience.
Communicate smart ideas with our expertise!`,
      },
      projectList: [
        "PubG Cafe",
        "NDLS Railway Station",
        "Snehin",
        "Epoxy",
        "Workshops",
      ],
      name: null,
      email: null,
      message: null,
      cardProfile3: {
        cardProfile1: require("@/assets/img/faces/card-profile1-square.jpg"),
        cardProfile2: require("@/assets/img/faces/card-profile6-square.jpg"),
        cardProfile3: require("@/assets/img/faces/card-profile4-square.jpg"),
        cardProfile4: require("@/assets/img/faces/card-profile2-square.jpg"),
      },
      whatWeOffer: {
        left: {
          title: "​Innovative Designs​",
          info: `Replication is a big no-no for us. Every client gets a fresh, customized illustration to match their needs.`,
          image: require("@/assets/img/wall-art/innovative_designs.png"),
        },
        middle: {
          title: "Valuable Features​",
          info: `Resistant to dust and stains, waterproof, tailored to all climates, long-lasting, durable designs.`,
          image: require("@/assets/img/wall-art/valuable_features.png"),
        },
        right: {
          title: "​AMC Service",
          info: `Our ‘Annual Maintenance Contract' scheme vows to properly maintain and/or fix any issues you face after we provide our services.`,
          image: require("@/assets/img/wall-art/amc_services.png"),
        },
      },
      clients: {
        logos: ["OasisLogo.jpg", "hokosoko.jpg", "WEWZone.png", "eximeng.png"],
        options: {
          autoplay: true,
          infinite: false,
          initialSlide: 0,
          autoplaySpeed: 10000,
          centerMode: true,
          dots: false,
          navButtons: false,
          slidesToShow: 2,
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        },
      },

      service1: {
        title: `Service 1`,
        icon: "3d_rotation",
        content: `Content1`,
      },

      service2: {
        title: `Service 2`,
        icon: "3d_rotation",
        content: `Content2`,
      },
      portfolio: {
        pubjiCafe: [
          {
            image: require("@/assets/img/landing/portfolio/wallart/1.jpg"),
            title: "Pub Ji Cafe",
            text: "Walls may have ears but they can also have Pub Jis",
          },
          {
            image: require("@/assets/img/landing/portfolio/wallart/2.jpg"),
            title: "Pub Ji Cafe",
            text: "Walls may have ears but they can also have Pub Jis",
          },
          {
            image: require("@/assets/img/landing/portfolio/wallart/3.jpeg"),
            title: "Pub Ji Cafe",
            text: "Walls may have ears but they can also have Pub Jis",
          },
          {
            image: require("@/assets/img/landing/portfolio/wallart/4.jpg"),
            title: "Pub Ji Cafe",
            text: "Walls may have ears but they can also have Pub Jis",
          },
          {
            image: require("@/assets/img/landing/portfolio/wallart/5.jpg"),
            title: "Pub Ji Cafe",
            text: "Walls may have ears but they can also have Pub Jis",
          },
          {
            image: require("@/assets/img/landing/portfolio/wallart/6.jpg"),
            title: "Pub Ji Cafe",
            text: "Walls may have ears but they can also have Pub Jis",
          },
          {
            image: require("@/assets/img/landing/portfolio/wallart/7.jpg"),
            title: "Pub Ji Cafe",
            text: "Walls may have ears but they can also have Pub Jis",
          },
          {
            image: require("@/assets/img/landing/portfolio/wallart/8.jpg"),
            title: "Pub Ji Cafe",
            text: "Walls may have ears but they can also have Pub Jis",
          },
          {
            image: require("@/assets/img/landing/portfolio/wallart/9.jpg"),
            title: "Pub Ji Cafe",
            text: "Walls may have ears but they can also have Pub Jis",
          },
          {
            image: require("@/assets/img/landing/portfolio/wallart/10.jpg"),
            title: "Pub Ji Cafe",
            text: "Walls may have ears but they can also have Pub Jis",
          },
          {
            image: require("@/assets/img/landing/portfolio/wallart/11.png"),
            title: "Pub Ji Cafe",
            text: "Walls may have ears but they can also have Pub Jis",
          },
          {
            image: require("@/assets/img/landing/portfolio/wallart/12.jpg"),
            title: "Pub Ji Cafe",
            text: "Walls may have ears but they can also have Pub Jis",
          },
        ],
      },

      counterDuration: 3000,
      counters: [
        {
          start: 0,
          end: 1000,
          title: "Spaces Embellished ",
        },
        {
          start: 0,
          end: 3000,
          title: "Gratified Clients",
        },
        {
          start: 0,
          end: 3000,
          title: "Weeks doing Business",
        },
        {
          start: 0,
          end: 3000,
          title: "Hours Invested ",
        },
      ],
      carousel: [
        {
          image: require("@/assets/img/home-carousel/1.jpg"),
          title: "Serving multiple personal and branding purposes",
          caption: "​Holistic Approach",
        },
        {
          image: require("@/assets/img/home-carousel/2.jpg"),
          title: "Catering to all your Artistic Needs",
          caption: "​Reliable Services",
        },
        {
          image: require("@/assets/img/home-carousel/3.jpg"),
          title: "A personalized outlook for every client",
          caption: "Client-Centric",
        },
      ],
      faqs: [
        {
          ques: "Is the material inclusive of your services?",
          ans: "Yes, the material for the project is inclusive of our services."
        },
        {
          ques: "What is the quality of paint used by you?",
          ans: " We only make use of high-quality paints that are dedicated to Wall Art."
        },
        {
          ques: "What is the quality of the material used for Wall Art?",
          ans: "Our premium quality material is dust and stain-resistant, waterproof, is adaptable to changing climates, and durable in nature."
        },
        {
          ques: "What is the average lifespan of the material used?",
          ans: "We collaborate with Experts from various paint brands that provide suggestions for the type of paint to be used taking into account your space’s surroundings and climate. Our Wall artwork stays in place for few to many years."
        },
        {
          ques: "How much does your service usually cost?",
          ans: "Our prices range from around ₹180/sq. ft. to about ₹2000/sq. ft. and this is completely dependent on the complexity of the design and the nature of the surface to be worked on."
        },
        {
          ques: "Is it possible to have Wall Art over a damp wall?",
          ans: "Yes, of course, it’s possible to have Wall Art over damp walls. But Artysan would first conduct a Water Treatment process before beginning to paint. Wall Art cannot directly be done on a damp wall."
        },
        {
          ques: "What type of Art Forms/Art Styles does Artysan usually create?",
          ans: " Our wide range of expertise spans a variety of Art Forms like Monochrome, Madhubani, Caricature, Abstract Art, Blended paintings, Silhouettes, Tropical designs, Doodles, and Character designs to name a few."
        },
      ],
      process: {
        image: require("@/assets/img/wall-art/roadmap.jpg")
      }
    };
  },
  methods: {
    openBlog(id, title) {
      title = title.replace(new RegExp(" ", "g"), "-");
      this.$router.push({ path: `/blog/${id}/${title}` });
    }
  },
  created() {
    const vm = this;
    firebase
      .firestore()
      .collection("blog")
      .where("type", "==", "PR")
      .orderBy("created", "desc")
      .limit(5)
      .get()
      .then(blogs => {
        blogs.forEach(blog => {
          const blogData = blog.data();
          const date = blogData.created.toDate();
          vm.blogs.push({
            title: blogData.title,
            author: blogData.author,
            cover: blogData.cover,
            created: {
              d: date.getDate(),
              m: date.getMonth(),
              y: date.getFullYear()
            },
            id: blog.id
          });
        });
        vm.loaded = true;
      });
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
